<template>
    <mode-switcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('price_lists_extra_services_creating')"
        :edit-mode-text="$t('price_lists_extra_services_editing')"
        @reset="priceListEditModalSelected = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :items="priceListsFiltered"
                :headers="headers"
                :loading="isPriceListsLoading"
                class="elevation-1 table-server"
                :sort-by="[{key: 'name', order: 'asc'}]"
                must-sort
            >
                <template v-slot:item.name="{item}">
                    <span class="text-link font-weight-medium text-decoration-underline" @click="showEditModal(item)">
                        {{ item.name }}
                    </span>
                </template>
                <template v-slot:item.dates="{item}">
                    {{ dateRange(item.tariffLinks) }}
                </template>
                <template v-slot:item.active="{item}">
                    <span>
                        {{ item.active ? $t('active') : $t('inactive') }}
                    </span>
                </template>
                <template v-slot:item.actions="{item}">
                    <span>
                        <v-btn variant="text" size="small" color="primary" @click="copyPriceList(item)">
                            {{ $t('copy') }}
                        </v-btn>
                    </span>
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <product-prices-extras-modal
                :price-list="priceListEditModalSelected"
                :contract="contract"
                :selected-locale="selectedLocale"
                @on-close="onCloseEditModal"
                @on-save="onPriceListSave"
            />
        </template>
    </mode-switcher>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import ProductPricesExtrasModal from '~/components/supplier/prices/modals/ProductPricesExtrasModal.vue'
    import {clone} from '@/utils/helpers'

    @Component({
        components: {
            ProductPricesExtrasModal,
        },
    })
    export class ProductPricesPriceLists extends Vue {
        @Prop() contract
        @Prop() selectedLocale
        @Prop() priceLists
        @Prop() isPriceListsLoading

        priceListEditModalSelected = null
        activeFilter = true

        @Emit()
        async onPriceListSave() {}

        showEditModal(priceList) {
            this.priceListEditModalSelected = priceList
            this.$refs.modeSwitcher.edit()
        }

        onCloseEditModal() {
            this.$refs.modeSwitcher.goToTable()
        }

        copyPriceList(priceList) {
            const priceListCopied = clone(priceList)

            delete priceListCopied.id
            delete priceListCopied.weekDays

            priceListCopied.tariffLinks.forEach(tl => {
                delete tl.linkId
            })

            priceListCopied.bookingDates.forEach(bd => {
                delete bd.id
            })

            priceListCopied.extraServicePrices.forEach(ep => {
                delete ep.id
            })

            this.showEditModal(priceListCopied)
        }

        get headers() {
            return [
                {title: this.$t('name'), value: 'name', sortable: true},
                {title: this.$t('dates'), value: 'dates'},
                {title: this.$t('status'), value: 'active'},
                {title: this.$t('actions'), value: 'actions'},
            ]
        }

        get priceListsFiltered() {
            return this.priceLists.filter(el => this.activeFilter === el.active)
        }

        dateRange(tariffs) {
            if (!tariffs.length) return ''
            let earliestDateFrom = tariffs[0].dateFrom
            let latestDateTo = tariffs[0].dateTo

            tariffs.forEach(tariff => {
                if (new Date(tariff.dateFrom) < new Date(earliestDateFrom)) {
                    earliestDateFrom = tariff.dateFrom
                }
                if (new Date(tariff.dateTo) > new Date(latestDateTo)) {
                    latestDateTo = tariff.dateTo
                }
            })

            return `${earliestDateFrom && this.$filters.dateShortFormat(earliestDateFrom)} - ${latestDateTo && this.$filters.dateShortFormat(latestDateTo)}`
        }
    }

    export default ProductPricesPriceLists
</script>
